export default __webpack_public_path__ + "static/media/blue-arrow.8784e236.svg";